import { useContext } from 'react';

import { Context } from './context';

export const useModalManagerPortal = () => {
  const { modalManagerRef } = useContext(Context);

  return modalManagerRef;
};
